import { render, staticRenderFns } from "./ExpressScan.vue?vue&type=template&id=0796a272&scoped=true"
import script from "./ExpressScan.vue?vue&type=script&lang=js"
export * from "./ExpressScan.vue?vue&type=script&lang=js"
import style0 from "./ExpressScan.vue?vue&type=style&index=0&id=0796a272&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0796a272",
  null
  
)

export default component.exports